 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"ae-js":"ae-js","bridge-vkapp-android":"bridge-vkapp-android","bridge-vkapp-ios":"bridge-vkapp-ios","bridge-vkpc-student":"bridge-vkpc-student","classroom-~classroom--vue~coursemodel-~coursemodel--vue":"classroom-~classroom--vue~coursemodel-~coursemodel--vue","classroom-":"classroom-","classroom--vue":"classroom--vue","coursemodel-":"coursemodel-","coursemodel--vue":"coursemodel--vue","fm-":"fm-","fm--vue":"fm--vue","hk-js":"hk-js","home-":"home-","home--vue":"home--vue","jp-js":"jp-js","k2-js":"k2-js","mocks":"mocks","tc-js":"tc-js","teachmaterials-":"teachmaterials-","teachmaterials--vue":"teachmaterials--vue","ts-js":"ts-js","tw-js":"tw-js","ucenter-report-":"ucenter-report-","ucenter-report--vue":"ucenter-report--vue","ucenter-report-RadarChart":"ucenter-report-RadarChart","ucenter-signin-":"ucenter-signin-","ucenter-signin--vue":"ucenter-signin--vue","vn-js":"vn-js"}[chunkId]||chunkId) + "." + {"ae-js":"18afd2bc","bridge-vkapp-android":"4c7ce10f","bridge-vkapp-ios":"df2d8548","bridge-vkpc-student":"6b7f0b68","classroom-~classroom--vue~coursemodel-~coursemodel--vue":"16ed06a0","classroom-":"1c53f331","classroom--vue":"10953f6a","coursemodel-":"3b978579","coursemodel--vue":"a66ccb64","fm-":"7101f558","fm--vue":"80e099aa","hk-js":"04a3cdb4","home-":"cc1d1392","home--vue":"19e28d50","jp-js":"414bb4b8","k2-js":"1a4de7cd","mocks":"e53ea93c","tc-js":"6aaeb171","teachmaterials-":"10d1735b","teachmaterials--vue":"7b51b7f8","ts-js":"d55e3c32","tw-js":"1d348e23","ucenter-report-":"cb8ff4cd","ucenter-report--vue":"0d4e4712","ucenter-report-RadarChart":"1499c40b","ucenter-signin-":"39ce678d","ucenter-signin--vue":"41a89eb8","vn-js":"427747ae"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"classroom-~classroom--vue~coursemodel-~coursemodel--vue":1,"classroom-":1,"classroom--vue":1,"coursemodel--vue":1,"fm-":1,"fm--vue":1,"home--vue":1,"teachmaterials--vue":1,"ucenter-report-":1,"ucenter-report--vue":1,"ucenter-report-RadarChart":1,"ucenter-signin--vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"ae-js":"ae-js","bridge-vkapp-android":"bridge-vkapp-android","bridge-vkapp-ios":"bridge-vkapp-ios","bridge-vkpc-student":"bridge-vkpc-student","classroom-~classroom--vue~coursemodel-~coursemodel--vue":"classroom-~classroom--vue~coursemodel-~coursemodel--vue","classroom-":"classroom-","classroom--vue":"classroom--vue","coursemodel-":"coursemodel-","coursemodel--vue":"coursemodel--vue","fm-":"fm-","fm--vue":"fm--vue","hk-js":"hk-js","home-":"home-","home--vue":"home--vue","jp-js":"jp-js","k2-js":"k2-js","mocks":"mocks","tc-js":"tc-js","teachmaterials-":"teachmaterials-","teachmaterials--vue":"teachmaterials--vue","ts-js":"ts-js","tw-js":"tw-js","ucenter-report-":"ucenter-report-","ucenter-report--vue":"ucenter-report--vue","ucenter-report-RadarChart":"ucenter-report-RadarChart","ucenter-signin-":"ucenter-signin-","ucenter-signin--vue":"ucenter-signin--vue","vn-js":"vn-js"}[chunkId]||chunkId) + "." + {"ae-js":"31d6cfe0","bridge-vkapp-android":"31d6cfe0","bridge-vkapp-ios":"31d6cfe0","bridge-vkpc-student":"31d6cfe0","classroom-~classroom--vue~coursemodel-~coursemodel--vue":"ebafbfc9","classroom-":"80b0c74a","classroom--vue":"44560d8a","coursemodel-":"31d6cfe0","coursemodel--vue":"adc6466a","fm-":"da10f447","fm--vue":"313b1bda","hk-js":"31d6cfe0","home-":"31d6cfe0","home--vue":"82686404","jp-js":"31d6cfe0","k2-js":"31d6cfe0","mocks":"31d6cfe0","tc-js":"31d6cfe0","teachmaterials-":"31d6cfe0","teachmaterials--vue":"5163fe29","ts-js":"31d6cfe0","tw-js":"31d6cfe0","ucenter-report-":"436e385b","ucenter-report--vue":"68c6fcbe","ucenter-report-RadarChart":"436e385b","ucenter-signin-":"31d6cfe0","ucenter-signin--vue":"6707574c","vn-js":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;
 				if (linkTag.href.indexOf(window.location.origin + '/') !== 0) {
 					linkTag.crossOrigin = "anonymous";
 				}
 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);
 				if (script.src.indexOf(window.location.origin + '/') !== 0) {
 					script.crossOrigin = "anonymous";
 				}
 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://s.vipkidstatic.com/fe-static/wombat/html/test/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
